/* unplugin-vue-components disabled */import script from "./Customer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Customer.vue?vue&type=script&lang=ts&setup=true"

import "./Customer.vue?vue&type=style&index=0&id=3c9b082b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9b082b"]])

export default __exports__